<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faClock } from "@fortawesome/free-regular-svg-icons"
import { faThumbtack } from "@fortawesome/free-solid-svg-icons"

library.add(faClock, faThumbtack)

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

const data = ref()
const count = ref(0)
const getData = async() => {
  await axios.get("./php/getTopics.php")
  .then((response) => {
    data.value = response.data.data
    count.value = response.data.count
  })
}

onMounted(() => {
  getData()
})
</script>

<template>
  <section v-if="count > 0" style="min-height: 10em;">
    <h4>最近のトピック</h4>
    <ul>
      <li v-for="topic in data" :key="topic.tid">
        <a :href="topic.url">
          <div class="css__text-left">
            <font-awesome-icon v-if="topic.is_pin" icon="fa-solid fa-thumbtack" size="lg" transform="rotate-315" />
            {{ topic.title }}
          </div>
          <div class="css__text-right" style="font-size: .85em;">
            <font-awesome-icon icon="fa-regular fa-clock" size="lg" />
            {{ topic.cre_dt }}
          </div>
        </a>
      </li>
    </ul>
  </section>
</template>

<style scoped>
  ul {
    list-style: none;
    padding: .5em .2em;
    margin: 0;
  }

  li {
    padding: 0;
    display: inline-block;
    position: relative;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, .05);
  }

  li a {
    display: block;
    margin: 0;
    padding: .5em .75em;
    color: #383c3c;
    text-decoration: none;
  }

  li a:hover {
    transition: .3s;
    background: rgba(0, 0, 0, .05);
  }

  li:first-child {
    border-top: 1px solid rgba(0, 0, 0, .05);
  }

  li.css__li-child {
    padding-left: 1em;
    border-left: .4em solid rgba(0, 0, 0, .05);
  }
</style>